import axiosInstance from "./service-instance";
import axios from "axios";
import { createUrl } from "utilities";
import { CONTENT_TYPES, CASE_TYPES } from "constants";
import { List } from "immutable";
import { getAuthToken } from "utilities/auth";
// const CASE_LIST_URL = createUrl(["case", "list", "v2"]);
const CASE_LIST_URL = createUrl(["case", "v2", "list", "test"]);
import Endpoint from "constants/endpoint";

const getCases = (caseStatus, stageId, page, page_size, filters) =>
    axiosInstance.get(CASE_LIST_URL, {
        params: {
            page,
            page_size,
            status: JSON.stringify(caseStatus === "INBOX" ? [1] : []),
            type: caseStatus.toLowerCase(),
            stage: stageId,
            ...filters
        },
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });

export const openCase = (caseID, caseEntry) =>
    axiosInstance.post("/case/create/", caseEntry).then(({ data, error }) => ({
        data,
        caseID,
        error
    }));


export const createCase = (caseEntry, contact_detail) => axiosInstance.post("/case/create/request/", {...caseEntry, contact_detail});

export const updateCaseMeta = (case_id, values) => axiosInstance.put(`/case/${case_id}/change/`, values);

export const updateCaseMasterLedgers = (case_id, values) => axiosInstance.put(`/case/${case_id}/supply-chain/`, values);


export const fetchCaseLedgerMasters = case_id => axiosInstance.get(`/case/${case_id}/ledger-masters/`, {
    params: {
        paginate: false
    }
});
export const previousCasesOverdue = (caseId) => axiosInstance.get(`/case/portfolio-data/view/?case_id=${caseId}`,
);

export const accountSummaryList = (caseIds) =>
    axiosInstance.get(`case/account-summary/list/?case_ids=[${caseIds}]`);

export const fiMovementAction = (body) => {
    return(axiosInstance.post("/case/fi-movement/action/", {...body}));};

export const generatePdPdf= (data) =>
    axios.post("https://template.progcap.com/generate-pd", data, {
        responseType: "blob"
    });


export class CaseStageService {
    resultsCount = CASE_TYPES.map(() => 0);

    pageSize = CASE_TYPES.map(() => CaseService.defaultPageSize);
    page = CASE_TYPES.map(() => ({
        next: false,
        prev: false,
        value: CaseService.defaultPage
    }));

    stage = null;
    stageId = null;

    constructor(props) {
        this.stage = props.name;
        this.stageId = props.id;
        this.pageSize = this.pageSize.merge(props.pageSize);
    }

    getCases = (caseType, page, pageSize) =>
        getCases(caseType, this.stageId, page, pageSize);

    next = caseType =>
        this.page.get(caseType).next
            ? getCases(
                caseType,
                this.stageId,
                this.page.get(caseType).value + 1,
                this.pageSize.get(caseType)
            ).then(({ data, error }) => {
                this.page = this.page.mergeIn([caseType], {
                    value: this.page.get(caseType).value + 1,
                    next: !!data.next,
                    prev: !!data.prev
                });
                return {
                    data: data.results,
                    done: false,
                    error
                };
            })
            : Promise.resolve({ data: [], done: true });
    prev = caseType =>
        this.page.get(caseType).prev
            ? getCases(
                caseType,
                this.stageId,
                this.page.get(caseType).value - 1,
                this.pageSize.get(caseType)
            ).then(({ data, error }) => {
                this.page = this.page.mergeIn([caseType], {
                    value: this.page.get(caseType).value - 1,
                    next: !!data.next,
                    prev: !!data.prev
                });
                return {
                    data: data.results,
                    done: false,
                    error
                };
            })
            : Promise.resolve({ data: [], done: true });
    current = caseType =>
        getCases(
            caseType,
            this.stageId,
            this.page.get(caseType).value,
            this.pageSize.get(caseType)
        ).then(({ data, error }) => {
            this.resultsCount = this.resultsCount.merge({
                [caseType]: data.count
            });
            this.page = this.page.merge({
                [caseType]: {
                    value: this.page.get(caseType).value - 1,
                    next: !!data.next,
                    prev: !!data.prev
                }
            });
            return {
                data: data.results,
                done: false,
                error
            };
        });

    getCount = caseType => this.resultsCount.get(caseType);
    static defaultPageSize = 50;
    static defaultPage = 1;
}

export class CaseService {
    serviceActive = false;
    stages = new List([]);
    init = stages => {
        if (!this.serviceActive && stages && stages.size > 0) {
            this.stages = stages.map(_ => _.name).toList();
            stages
                .map(
                    _ =>
                        new CaseStageService({
                            name: _.name,
                            id: _.id,
                            pageSize: CASE_TYPES.map(() => 10)
                        })
                )
                .map((service, name) => (this[name] = service));
            this.serviceActive = true;
        }
    };

    deactivateCaseService = () => {
        this.serviceActive = false;
        this.stages = new List([]);
    };

    current = (caseType, stageFilter) =>
        Promise.all(
            this.stages
                .filter(_ => (stageFilter ? stageFilter.includes(_) : true))
                .map(_ => this[_].current(caseType))
                .toArray()
        ).then(results => {
            return Promise.resolve({
                data: this.stages
                    .filter(_ => (stageFilter ? stageFilter.includes(_) : true))
                    .toMap()
                    .flip()
                    .map(_ => results[_].data),
                error: null
            });
        });
    next = (caseType, stageFilter) =>
        Promise.all(
            this.stages
                .filter(_ => (stageFilter ? stageFilter.includes(_) : true))
                .map(_ => this[_].next(caseType))
                .toArray()
        ).then(results =>
            Promise.resolve({
                data: this.stages
                    .filter(_ => (stageFilter ? stageFilter.includes(_) : true))
                    .toMap()
                    .flip()
                    .map(_ => results[_].data),
                error: null
            })
        );

    getCaseDetail = case_id => axiosInstance.get(createUrl(["case", case_id]));
    bulkCaseCreate = (data) => axiosInstance.post(createUrl(["case", "bulk-create"]), data, {
        headers: {
            "Content-Type": "multipart/form-data"    
        }
    }); 
    updateCaseDetail = (case_id, caseDetail) =>
        axiosInstance.put(createUrl(["case", case_id]), caseDetail);

    updateCaseRemarks = (case_id, remarks, internal_remarks) =>
        axiosInstance.put(createUrl(["case", case_id, "remarks"]), {remarks, internal_remarks}, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    updateSanctionLimit = (case_id, caseDetail) =>
        axiosInstance.put(createUrl(["case", case_id, "update"]), caseDetail);

    upgradeAssignCase = (case_task_id, data) =>
        axiosInstance.put(createUrl(["case", "assign", case_task_id]), data, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    upgradeReassignCase = (case_task_id, data) =>
        axiosInstance.put(createUrl(["case", "reassign", case_task_id]), data, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    upgradeProceedCase = (case_task_id, data) =>
        axiosInstance.put(createUrl(["case", "proceed", case_task_id]), data, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    upgradeReferCase = (case_task_id, data) =>
        axiosInstance.put(createUrl(["case", "refer", case_task_id]), data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    
    updateChannelProductStat = (case_id, data) => {
        return axiosInstance.post(`/case/${case_id}/channel-product-stat/`, data, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        });
    };

    getCaseAssociates = (case_id) =>
        axiosInstance.get(`/case/${case_id}/associate-list/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    addCaseAssociates = (caseId, company_associates) =>
        axiosInstance.put("/case/add-remove-associates/", {
            case: caseId,
            company_associates
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    deleteCaseAssociates = (caseId, company_associates) =>
        axiosInstance.delete("/case/add-remove-associates/", {
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                case: caseId,
                company_associates
            }
        });

    getCaseBankAccounts = (case_id) =>
        axiosInstance.get(`case/${case_id}/company-bank-account/update/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    addCaseBankAccounts = (caseId, company_bank_account) =>
        axiosInstance.put(`case/${caseId}/company-bank-account/update/`, {
            company_bank_account,
            case: caseId
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    deleteCaseBankAccounts = (caseId, company_bank_account) =>
        axiosInstance.delete(`case/${caseId}/company-bank-account/update/`, {
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                case: caseId,
                company_bank_account
            }
        });
    
    getChannelProductStat = case_id =>
        axiosInstance.get(`/case/${case_id}/channel-product-stat/`);

    upgradeRejectCase = (case_id, rejection_reason, rejection_remarks) =>
        axiosInstance.put(createUrl(["case", "reject", case_id]), {
            rejection_reason,
            rejection_remarks
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    getCasesCount = type =>
        axiosInstance.get(createUrl(["case", "count"]), {
            params: {
                type
            }
        });
    getActiveCaseTask = caseId =>
        axiosInstance.get(createUrl(["case", "case-task", caseId]));
    bulkReferCase = (caseIds, this_stage, this_user, reassignment_reason) =>
        axiosInstance.post("/case/refer/bulk/", {
            case_task_ids: caseIds,
            this_stage,
            this_user,
            reassignment_reason
        });
    bulkApprove = (case_task_ids, stage, user, remarks) => {
        return axiosInstance.post(
            createUrl(["case", "proceed", "bulk"]),
            {
                case_task_ids,
                this_stage: stage,
                this_user: user,
                remarks
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    };
    bulkReject = (caseIds, reason, remarks) =>
        axiosInstance.post("/case/reject/bulk/", {
            case_ids: caseIds,
            rejection_reason: reason,
            rejection_remarks: remarks
        });

    downloadApplicationFormForJana = (case_id, application_form) =>
        axiosInstance.get(`/case/${case_id}/application-form-generate/`, {
            params: {
                application_form
            },
            responseType: "blob"
        });
    
    addNewChannelProduct = (data) =>
        axiosInstance.post("/master/channel-product/create/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    updateCaseQuestionnaire = (caseId, pdData) =>
        axiosInstance.post(`/case/${caseId}/questionnaire/get-update/`, pdData, {
            headers: {
                "Content-Type": "application/json",
            }
        });
    caseSearchList = (gstin) =>
        axiosInstance.get("/case/search/list/", {
            params: {
                gstin
            }
        });
    newCaseSearchList = (caseId) =>
        axiosInstance.get(`/case/previous-case/?case_id=${caseId}`, {
        });
        
    getPreviousSanctionedList = (caseId) =>
        axiosInstance.get(`/case/${caseId}/sanctioned-case/list/`);
    
    updateCaseStatus = (caseId, case_type) => {
        if(case_type === "4") {
            return axiosInstance.post(`/case/${caseId}/amendment/`, {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } else {
            return axiosInstance.post(`/case/${caseId}/renew-enhance/`, {
                case_type
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
        }
    }
    updateProcessingFee = (caseId, processing_fee_amount) =>
        axiosInstance.post(`/case/${caseId}/los-to-lms/`, {
            processing_fee_amount
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    holdCase = (case_id, hold_remarks, action_reason) =>
        axiosInstance.post(`/case/${case_id}/hold/`, {
            hold_remarks,
            action_reason
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    openHoldCase = (case_id, open_remarks) =>
        axiosInstance.post(`/case/${case_id}/open/`, {
            open_remarks
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    confirmDistributorScheme = (caseId) =>
        axiosInstance.get(`/case/${caseId}/confirmation-distributor-scheme/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    downloadScoreCard = (caseId, score_card_type) =>
        axiosInstance.post("/case/score-card/download/", {}, {
            params: {
                case: caseId,
                score_card_type
            },
            responseType: "arraybuffer"
        });

    deleteAgreementRequest = (case_Id) => 
        axiosInstance.delete(createUrl(["case", case_Id, "legality"]),{
            headers: {
                "Content-Type": "application/json"
            }
        });

    fetchCaseAgreementData = (case_Id) =>
        axiosInstance.get(createUrl(["case", case_Id, "legality"]), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    
    fetchCaseAgreementSignatureList = (case_Id) =>
        axiosInstance.get(createUrl(["case", case_Id, "invitees_legality"]), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    
    fetchInitiatAgreement = (case_Id) =>
        axiosInstance.post(createUrl(["case", case_Id, "legality"]), {},  {
            headers: {
                "Content-Type": "application/json"
            }
        });

    fetchCaseAgreementPdf = (case_id, html) =>
        axiosInstance.post(createUrl(["case", "legality_html_pdf"]), {
            case_id,
            html
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    retriggerAgreement = (case_id, retrigger_reason) =>
        axiosInstance.post(createUrl(["case", case_id, "legality"]), {retrigger_reason});
    downloadCasesXlsx = ({
        stageIds,
        type
    }) => 
        axiosInstance.get(createUrl(["case", "export"]), {
            params: {
                stage_ids: JSON.stringify(stageIds),
                type
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    getSanctionConditions = (caseId) =>
        axiosInstance.get(`/case/${caseId}/sanction-condition/`, {
            params: {
                "Content-Type": "application/json"
            }
        });
    terminateSanctionConditions = (caseId, sanction_condition_termination_remarks) =>
        axiosInstance.post(`/case/${caseId}/sanction-condition/termination/`, {
            sanction_condition_termination_remarks
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });
         updateProcessingFeeAmount = (caseId, PFAmount) =>(
             axiosInstance.post(`case/${caseId}/update/processing-fee/`, {processing_fee_amount:PFAmount},{
                 headers: {
                     "Content-Type": "application/json"
                 }
             }));         
             
    generateCreditSummaryDemoV2 = data =>
        axios.post("https://template.progcap.com/generate-case-summary/V2", data);

    generateCreditSummary = data =>
        axios.post("https://template.progcap.com/generate-case-summary", data);
        // axios.post("http://localhost:8000/generate-case-summary", data);

    generategetCamview = data =>
        axios.post("https://template.progcap.com/generate-camview/", data);  
    generategetCamviewV2 = data =>
        axios.post("https://template.progcap.com/generate-camview/V2/", data);  

    uploadBankStatementAnalysis = (data) =>
        axiosInstance.post("/statement_analyzer/file/upload/", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

    uploadBankStatementAnalysisPerfios = (data) =>
        axiosInstance.post("/statement_analyzer/perfios/file/upload/", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

    getMasterBankList = () =>
        axiosInstance.get("/statement_analyzer/bank/list/");
    getMasterBankListPerfios = (provider) =>
        axiosInstance.get(`/statement_analyzer/bank/list/?provider=${provider}`);
    getJobList = (case_id) =>
        axiosInstance.get("/statement_analyzer/statement-analysis/list/", {
            params: {
                case_id
            }
        });
    getJobDetails = (request_id) =>
        axiosInstance.get("/statement_analyzer/request/status/", {
            params: {
                request_id
            }
        });
    getJobDetailsPerfios = (request_id) =>
        axiosInstance.get("/statement_analyzer/perfios/request/status/", {
            params: {
                request_id
            }
        });
    getStatementAnalysis = (request_id) =>
        axiosInstance.get("/statement_analyzer/get-analysis-summary/", {
            params: {
                request_id
            }
        });
    getStatementAnalysisPerfios = (request_id) =>
        axiosInstance.get("/statement_analyzer/perfios/get-analysis-summary/", {
            params: {
                request_id
            }
        });
    retryAnalysis = (request_id) =>
        axiosInstance.get("/statement_analyzer/analysis-request/retry/", {
            params: {
                request_id
            }
        });
    retryAnalysisPerfios = (request_id) =>
        axiosInstance.get("/statement_analyzer/perfios/analysis-request/retry/", {
            params: {
                request_id
            }
        });
    downloadBankStatement = (request_id) =>
        axiosInstance.get("/statement_analyzer/bank-statement/download/", {
            params: {
                request_id
            },
            responseType: "arrayBuffer"
        });

    getCreditAssessment = (caseId) =>
        axiosInstance.get(`/case/${caseId}/credit-assessment/create-retrieve/`);
    
    updateCreditAssessment = (caseId, data) =>
        axiosInstance.put(`/case/${caseId}/credit-assessment/create-retrieve/`, data);
    
    refreshCreditAssessmentData = (caseId) =>
        axiosInstance.get(`/case/${caseId}/credit-assessment/create-retrieve/`, {
            params: {
                refresh: true
            }
        });

    createBulkAdhocCases = (data) =>
        axiosInstance.post("case/bulk/case-enhancement/", data);

    createBulkPayProCases = (data) =>
        axiosInstance.post("case/payment-program/upload/", data);
    
    getExistingCaseLimit = (caseId) =>
        axiosInstance.get(`/case/${caseId}/existing-detail/`);
    
    getCaseSellers = (caseId) =>
        axiosInstance.get("/case/seller/", {
            params: {
                case_id: caseId
            }
        });
    
    getCaseLedgerStatus = (case_id) =>
        axiosInstance.get("/case/get-ledger-status/", {
            params: {
                case_id
            }
        });
    fetchCaseChecklist = (caseId) =>
        axiosInstance.get(`/case/${caseId}/checklist/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    uploadCaseLedgers = (data) =>
        axiosInstance.post("/case/request-ledger/upload/", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    
    getRejectReasonsList = (stage_id) =>
        axiosInstance.get("/master/workflow-assignment/category-wise/reasons/", {
            params: {
                stage_id
            }
        });
    createPodDetails = (data) => 
        axiosInstance.post("/case/ps-kit/courier-details/", data);
    updatePskitCourier = (data) =>
        axiosInstance.put("/case/ps-kit/courier-details/", data);
    getPskitCourierDetails = () =>
        axiosInstance.get("/case/ps-kit/courier-details/");
    getCategoryWiseReasons = (stage_id, action) =>
        axiosInstance.get("/master/workflow-assignment/category-wise/reasons/", {
            params: {
                stage_id,
                action
            }
        });
    getAnalysisTypeOptions = () =>
        axiosInstance.get("/statement_analyzer/analysis-type/");
    createStatementAnalysis = (data) =>
        axiosInstance.post("/statement_analyzer/application-id-analysis/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    updateCaseLedgerDate = (caseId, data) =>
        axiosInstance.put(`/case/${caseId}/case-finacial/`, data);

    getCaseLedgerDate = (caseId) =>
        axiosInstance.get(`/case/${caseId}/case-finacial/`);

    getLendersCam = (case_id) =>
        axiosInstance.get(`/case/${case_id}/case-cam-recommendation/`);

    getSingleLendersCam = (case_id, case_cam_id) =>
        axiosInstance.get(`/case/${case_id}/case-cam-recommendation/`, {
            params: {
                case_cam_id
            }
        });

    postLendersCam = (case_id) =>
        axiosInstance.post(`/case/${case_id}/case-cam-recommendation/`);
    
    UnAssignCase = (case_task_id, data) =>
        axiosInstance.put(`case/un-assign/${case_task_id}/`, data)
        
    postEsignAgreement = (data, hitSignzy) =>{
        let url = hitSignzy ? "/legality/v3/db/create-template/" : "/company/esign_agreement/";
        return axiosInstance.post(url, data);
        // return axiosInstance.post("/legality/v3/db/create-template/", data);
    }
    downloadBankStatementReport = (reqId) =>
        axiosInstance.get(`/statement_analyzer/perfios/bank-statement/download/?request_id=${reqId}`, {
            headers: {
                Authorization: `Bearer ${getAuthToken().authToken}`
            },
            responseType: "blob"
        });

    downloadBankStatementErrReport = (reqId) =>
        axiosInstance.get(`/statement_analyzer/perfios/process/failure/?request_id=${reqId}`, {
            headers: {
                Authorization: `Bearer ${getAuthToken().authToken}`
            },
            responseType: "blob"
        });
    
    updateBankStatementChequeData = (requestId, data) =>
        axiosInstance.post(`statement_analyzer/update-statement-analysis/${requestId}/`, data);
        
    fetchCaseCibilAllApplicants = (case_id) => 
        axiosInstance.get('case/customer/cibil/v2/' ,{
            params : {
                case_id
            }
        });
    triggerCibilConsumer = (case_id, applicant_id) => axiosInstance.post('case/customer/cibil/v2/' , {
        case_id,
        applicant_id,
        source: "SOUL" 
    })

    triggerCibilCommercial = (case_id) => axiosInstance.post('case/commercial/cibil/v2/' , {
        case_id,
        source: "SOUL" 
    })
    deferralTag = (case_id, action, body) => axiosInstance.post(Endpoint.deferralTag.replace(':case_id', case_id), body)

    getCaseRemarks = (case_id) =>
        axiosInstance.get(createUrl(["case", case_id, "remarks"]),  {
            headers: {
                "Content-Type": "application/json"
            }
    });
    getApprovalDetails = (case_id) => 
        axiosInstance.get(`case/${case_id}/approval/by-approver/`,  {
            headers: {
                "Content-Type": "application/json"
            }

    });
    OverdueCibilAccountDetails = (case_id) => 
        axiosInstance.get(Endpoint.OverdueCibilAccountDetails.replace(':case_id', case_id),  {
            headers: {
                "Content-Type": "application/json"
            }

    });

    postApprovalDetails = (case_id, formData) => 
        axiosInstance.post(`case/${case_id}/approval/by-approver/`, formData ,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
    });
    updateCamsData = (case_id, data) =>  
        axiosInstance.post(`case/${case_id}/update/cam-automation/`, data ,{
        headers: {
            "Content-Type": "application/json"
        },    
    });
    refreshCamsData = (case_id, data) =>  
        axiosInstance.post(`case/${case_id}/update/cam-automation/?refresh=true`, data ,{
        headers: {
            "Content-Type": "application/json"
        },
    });
    updateCamsBreachedCaseStatus = (case_id, data) =>  
        axiosInstance.post(`case/${case_id}/cam-engine-breached-case-status/`, data ,{
        headers: {
            "Content-Type": "application/json"
        },
    });
    getCamsBreachedCaseStatus = (case_id) =>  
        axiosInstance.get(`case/${case_id}/cam-engine-breached-case-status/`,{
        headers: {
            "Content-Type": "application/json"
        },
    });
    getNachMandateDetails = (caseId, data) => 
        axiosInstance.get(`case/${caseId}/enach-mandate/`, {
            params: data
        }, {
            headers: {
                "Content-Type": "application/json"
            }
    });
    getEnachStatus  = (caseId) => 
        axiosInstance.get(`case/${caseId}/enach-status/`,  {
            headers: {
                "Content-Type": "application/json"
            }
    });
    triggerEnach = (case_id, data) =>  
        axiosInstance.post(`case/${case_id}/enach/`, data ,{
        headers: {
            "Content-Type": "application/json"
        },
    });
    noNachPDCTrigger = (case_id,emi_date, data) =>
        axiosInstance.post(`case/${case_id}/update-term-loan/${emi_date}/`, data, {
            headers: {
                "Content-Type": "application/json"
            },
        });
    uploadPhysicalNach = (case_id, formData) => {
        return axiosInstance.post(`case/${case_id}/physical-enach-mandate/`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });
    };

    cancelNachMandate = (caseId, bank_nach_id, emi_date) => {
        return axiosInstance.post(`case/${caseId}/enach-request-cancel/`, {
            bank_nach_id,
            emi_date
        }, {
            headers: {
                "Content-Type": "application/json"
            },
        });
    }
    submitEligibilityCalculatorDetails = (case_id, data) => 
        axiosInstance.post(`case/${case_id}/eligibility/calculator/`, data ,{
            headers: {
                "Content-Type": "application/json"
            }});
    getEligibilityCalculatorDetails = (case_id, data) => 
            axiosInstance.get(`case/${case_id}/eligibility/calculator/`, {
                headers: {
                    "Content-Type": "application/json"
                }});
    updateTermLoanTenorROi = (case_id, data) => 
        axiosInstance.post(`case/${case_id}/tenor-roi-update/`,data ,{
            headers: {
                "Content-Type": "application/json"
            }});

    updateCaseDetailV2 = (case_id, data) => {
        return axiosInstance.patch(`case/${case_id}/`,data ,{
            headers: {
                "Content-Type": "application/json"
            }});
    }

    updateCaseDetailCPV = (case_id, data) => {
        return axiosInstance.post(`case/${case_id}/applicant-cpv/`,data ,{            
            headers: {
                "Content-Type": "application/json"
            }});
    }
    updateCaseDetailFTR = (case_id, data) => {
        return axiosInstance.post(`case/${case_id}/tag-ftr/`,data ,{
            headers: {
                "Content-Type": "application/json"
            }});
        }
    getRetailerRiskControlDetail = (case_id, company_id) => {
        return axiosInstance.get(`company/retailer/mpa-details/`,{
            params:{
                case_id,
                company_id,
            },
            headers: {
                "Content-Type": "application/json"
            }});
    }
    updateRetailerRiskControlDetail = (data, method) => {
          const url = "company/retailer/mpa-details/";
        if (method === "put") {
            return axiosInstance.put(url, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
        }

        // default: POST
        return axiosInstance.post(url, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });

    }

    updateCaseCategoryTag = (case_id, data) => {
        return axiosInstance.post(`case/${case_id}/update-case-category/`,data ,{
            headers: {
                "Content-Type": "application/json"
            }});
    }

    getCaseCategoryTag  = (caseId) =>
        axiosInstance.get(`case/${caseId}/update-case-category/`,  {
            headers: {
                "Content-Type": "application/json"
            }
        });
    
    saveCamViewComments = (case_id, body) => {
        return axiosInstance.post(`case/${case_id}/cam-view-comments/`, body,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    
    updateCamViewComments = (case_id, body) => {
        return axiosInstance.patch(`case/${case_id}/cam-view-comments/`, body,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    
    getCamViewComments = (case_id) => {
        return axiosInstance.get(`case/${case_id}/cam-view-comments/`,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    
    getCamViewCreditSummary = (case_id, body) => {
        return axiosInstance.get(`case/${case_id}/credit-summary-via-chatgpt/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    
    approveCamsCase = (case_id) => {
        return axiosInstance.get(`case/${case_id}/approval/by-approver/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    getCaseBusinessProductTypeDesc = (case_id , business_product_type) => {
    return axiosInstance.get(`case/${case_id}/scheme-basis-product-type/`, {
        params: {
                business_product_type: business_product_type
        },
            headers: {
                "Content-Type": "application/json"
            },
            
        });

    }
    updateBundledLimit = (case_id, data) => {
        return axiosInstance.put(`case/${case_id}/update-bundle-limit/`,data ,{
            headers: {
                "Content-Type": "application/json"
            }});
    }
    getEligibilityCalculatorData = (case_id) => {
        return axiosInstance.get(Endpoint.eligibilityCalculator.replace(':case_id', case_id), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    approveRejectAuthorityApprovalFounders = (case_id, email , status) => {
        return axiosInstance.get(`case/${case_id}/approval/by-approver/via-email-link/?status=${status}&email=${email}`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    pdDeclarationSaveDetails = (caseId, values) => {
        return axiosInstance.post(`case/${caseId}/pd-declaration/`, {
            ...values
        } ,{
            headers: {
                "Content-Type": "application/json"
            }
        });

    }

    getCaseJsonData = (caseId) => {
        return axiosInstance.get(`case/${caseId}/pd-declaration/`,{
            headers: {
                "Content-Type": "application/json"
            }
        });

    }
    getCaseListingData = (caseIds) => {
        const caseIdsStr = Array.isArray(caseIds)
            ? caseIds.join(",")
            : caseIds;

        return axiosInstance.get(`case/case-listing/details/`, {
            params: {
                case_ids: caseIdsStr
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    caseBulkApproveRejectByCaseApprover = (case_ids, status, email) => {
        return axiosInstance.post(`case/bulk-approval/by-approver/via-email-link/`, {
            case_ids,
            email,
            status
        } ,{
            headers: {
                "Content-Type": "application/json"
            }
        });

    }

    caseAISummaryAutomation = (case_id, refresh = false) => {
        return axiosInstance.get(Endpoint.caseAISummaryAutomation.replace(':case_id', case_id), {
            params: refresh ? { refresh: true } : {}
        });
    }

    getCaseDetailFields = (case_id) => {
        return axiosInstance.get(`case/${case_id}/case-detail-fields/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    updateCaseDetailFields = (case_id, data) => {
        return axiosInstance.put(`case/${case_id}/case-detail-fields/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

}

export const getCasesForAStage = (type, stage, page, page_size, filters) =>
    getCases(
        type,
        stage,
        page,
        page_size,
        filters
    ).then(({ data, error }) =>
        Promise.resolve({
            data: data,
            error: error
        })
    );
export default new CaseService();
